import { Component } from '@angular/core';
import { LoginService } from '../login_service/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModelService } from 'src/app/services/model.service';

@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.scss']
})
export class RecoverComponent {

	public loading: boolean = false;
	public email: string;

	constructor(
		private loginService: LoginService,
		public modelService: ModelService,
		private route: ActivatedRoute,
		private router: Router) {

	}

	public recoverPassword() {

		this.loading = true;

		this.loginService.recover(this.email)
			.subscribe(
				(data: any) => {
					this.router.navigate(['/login']);
				},
				(error: Error) => {
					// this.alertService.error(error);
					setTimeout(() => this.loading = false, 2000);
				});
	}
}
